import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';

import './global.css';
import './configs/font';
import './configs/axios';
import { getGAUserId } from './analytics';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

getGAUserId();

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
